import { render, staticRenderFns } from "./PrivilegesReview.vue?vue&type=template&id=20666684&"
import script from "./PrivilegesReview.vue?vue&type=script&lang=js&"
export * from "./PrivilegesReview.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegesReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PrivilegesReview.vue"
export default component.exports